module.exports = __webpack_public_path__ + "img/IMG_0328_L_WoodMatted.3fb5872d.jpg";